<form [formGroup]="poiForm" class="flex flex-col gap-6 pl-2 w-full" [class]="direction" [ngClass]="{'!w-[31.25rem] pr-2' : isDesktop}">
  <!--
    a11y: close (X) reordered FIRST in DOM (order-2 keeps it visually on the
    trailing side, order-1 keeps the icon+heading on the leading side).
    [focusInitial]=true makes the CDK focus trap put initial focus on this
    button on open. Rendered on mobile too to satisfy the audit ("every
    popup must expose a close button at the top + receive initial focus").
  -->
  <div class="flex justify-between items-center">
    <mot-button matType="icon" icon="close"
      [ariaLabel]="closeText"
      class="!border-none !w-min !h-min cursor-pointer !bg-transparent order-2" iconClass="!text-2xl"
      buttonClass="!bg-transparent"
      [focusInitial]="true"
      (onClick)="closeCard()" />
    <div class="flex gap-2 items-center order-1">
      <ng-icon class="text-2xl" name="buildings" aria-hidden="true" />
      <!-- a11y: popup heading is h2 (page-level h1 is the nav-bar logo). -->
      <h2 class="text-base">{{askPoiText}}</h2>
    </div>
  </div>

  <div class="flex flex-col gap-2">
    <span class="font-normal">{{fillDetailsText}}</span>
    <mot-input formControlName="name" [placeholder]="poiNameText" class="w-full" [displayErrors]="false" [dir]="direction"/>
    <div class="flex items-center">
      <ng-icon [name]="'circle-info'" class="text-2xl text-[#5C748F]"/>
      <span class="font-normal text-xs mt-1">{{mandatoryFieldText}}</span>
    </div>
    <mot-input formControlName="address" [placeholder]="addressText" class="w-full" [displayErrors]="false" [dir]="direction"/>
  </div>

  <div class="flex gap-2" [ngClass]="[isMobile ? 'flex-col' : 'items-center justify-end']">
    <mot-button [disabled]="!poiForm.valid"
      buttonClass="not-disabled:!bg-primary not-disabled:!text-white w-full !text-[#B4BFCB] !py-6 !rounded-lg !align-middle" [text]="sendText"
    (onClick)="sendPOI()"></mot-button>

    <mot-button buttonClass="!bg-transparent w-full !text-black !align-middle" [text]="cancelText"
    (onClick)="closeCard()"></mot-button>
  </div>

</form>